function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import { cmsActions } from '../../reducers/cms.reducer';
import { modalActions } from '../../reducers/modal.reducer';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import Table from '../common/table/Table.react';
import UsersAdd from './UsersAdd.modal';
import AccessRestricted from '../app/routing/AccessRestricted.react';
var Users = function Users(_ref) {
  var booted = _ref.booted,
    isLoggedIn = _ref.isLoggedIn,
    cmsUsers = _ref.cmsUsers,
    usersAction = _ref.usersAction,
    addModalAction = _ref.addModalAction;
  var navigate = useNavigate();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    filter = _useState2[0],
    setFilter = _useState2[1];
  useEffect(function () {
    usersAction({});
  }, [booted, isLoggedIn]);
  if (!useHasPermission('view-users')) return /*#__PURE__*/React.createElement(AccessRestricted, null);
  cmsUsers = Object.values(cmsUsers).map(function (x) {
    var _x$profile, _x$profile2;
    var primaryEmail = x.email.filter(function (y) {
      return y.primary;
    })[0];
    return {
      _id: x._id,
      role: x.role,
      signupDate: x.signupDate,
      lastLogin: x.lastLogin,
      lastActive: x.lastActive,
      email: primaryEmail === null || primaryEmail === void 0 ? void 0 : primaryEmail.address,
      emailVerified: (primaryEmail === null || primaryEmail === void 0 ? void 0 : primaryEmail.verificationCode) === null,
      firstName: ((_x$profile = x.profile) === null || _x$profile === void 0 ? void 0 : _x$profile.firstName) || '',
      lastName: ((_x$profile2 = x.profile) === null || _x$profile2 === void 0 ? void 0 : _x$profile2.lastName) || ''
    };
  });
  var usersTable = {
    data: cmsUsers,
    columns: {
      _id: {
        title: 'ID',
        visible: false
      },
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'E-mail',
      role: 'Account Type'
    },
    tr: {
      onClick: function onClick(row) {
        navigate("/user/".concat(row._id));
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "User Profiles",
    button: {
      label: 'New User',
      type: 'add',
      permission: 'edit-users',
      onClick: function onClick() {
        addModalAction({
          component: /*#__PURE__*/React.createElement(UsersAdd, null)
        });
      }
    },
    search: {
      query: filter,
      onChange: function onChange(e) {
        return setFilter(e.target.value);
      },
      label: 'Search Users:',
      placeholder: 'Search...'
    }
  }), /*#__PURE__*/React.createElement(Table, _extends({}, usersTable, {
    sort: {
      by: 'email'
    },
    filter: filter,
    filterColumns: ['_id', 'email', 'role']
  })))));
};
var mstp = function mstp(s) {
  return {
    booted: s.app.booted,
    isLoggedIn: s.app.isLoggedIn,
    cmsUsers: s.cms.users
  };
};
var mdtp = {
  addModalAction: modalActions.add,
  usersAction: cmsActions.users
};
export default connect(mstp, mdtp)(Users);